import enterprise from './enterprise.js'
import account from './account.js'
import role from './role'

export default {
    enterprise: enterprise,
    account: account,
    role,
    // 提升常用方法到顶层，避免 enterprise.enterprise.getOrgs 的嵌套
    getOrgs: enterprise.getOrgs,
}
